/**
 * @description Specifies the different itct fields vs econfigure model fields mapping and helper functions
 */
export const FeasibilityType = {
    "Type": ["Selector.varType"],
    "VoltageLevel": ["Selector.varType"],
    "Current": ["Selector.varType"],
    "Dimension": ["Selector.varType"],
    "PrimaryTerminals": ["Selector.varType"],
    "Ratio": ["Selector.varCompleteratioA"],
    "Standard": ["Selector.varStandard"],
    "InsulationLevel": ["Selector.varInsulationvoltagekV"],
    "ThermalCurrent": ["Selector.varIthtimeIdynkA"],
    "ThermalCurrentTime": ["Selector.varIthtimeIdynkA"],
    "DynamicCurrent": ["Selector.varIthtimeIdynkA"],
    "Frequency": ["Selector.varFrequencyHz"],
    "AmbientTemperature": ["Selector.varAmbienttemperature"],
    "Altitude": ["Selector.varAltitudem"],
    "Icont": ["Selector.varIcthA"],
    "Accessories": ["Selector.varPolarity", "Selector.varCapacitivedDivider"],
    "CoreExtension": [
        "Selector.GrpCore1.varCore1Extension",
        "Selector.GrpCore2.varCore2Extension",
        "Selector.GrpCore3.varCore3Extension",
        "Selector.GrpCore4.varCore4Extension",
        "Selector.GrpCore5.varCore5Extension",
        "Selector.GrpCore6.varCore6Extension"
    ],
    "CorePrecisionClass": [
        "Selector.GrpCore1.varCore1Accuracyclass",
        "Selector.GrpCore2.varCore2Accuracyclass",
        "Selector.GrpCore3.varCore3Accuracyclass",
        "Selector.GrpCore4.varCore4Accuracyclass",
        "Selector.GrpCore5.varCore5Accuracyclass",
        "Selector.GrpCore6.varCore6Accuracyclass"
    ],
    "CoreSecurityFactor": [
        "Selector.GrpCore1.varCore1Fs",
        "Selector.GrpCore2.varCore2Fs",
        "Selector.GrpCore3.varCore3Fs",
        "Selector.GrpCore4.varCore4Fs",
        "Selector.GrpCore5.varCore5Fs",
        "Selector.GrpCore6.varCore6Fs",
    ],
    "CoreBurden": [
        "Selector.GrpCore1.varCore1BurdenVA",
        "Selector.GrpCore2.varCore2BurdenVA",
        "Selector.GrpCore3.varCore3BurdenVA",
        "Selector.GrpCore4.varCore4BurdenVA",
        "Selector.GrpCore5.varCore5BurdenVA",
        "Selector.GrpCore6.varCore6BurdenVA"
    ],

    "Selector.varType": ["Type", "VoltageLevel", "Current", "Dimension", "PrimaryTerminals"],
    "Selector.varCompleteratioA": ["Ratio"],
    "Selector.varStandard": ["Standard"],
    "Selector.varInsulationvoltagekV": ["InsulationLevel"],
    "Selector.varIthtimeIdynkA": ["ThermalCurrent", "ThermalCurrentTime", "DynamicCurrent"],
    "Selector.varFrequencyHz": ["Frequency"],
    "Selector.varAmbienttemperature": ["AmbientTemperature"],
    "Selector.varAltitudem": ["Altitude"],
    "Selector.varIcthA": ["Icont"],
    "Selector.varPolarity": [],
    "Selector.varInsulationclass": [],
    "Selector.varCapacitivedDivider": ["Accessories"],
    "Selector.GrpCore1.varCore1Accuracyclass": ["CorePrecisionClass"],
    "Selector.GrpCore1.varCore1BurdenVA": ["CoreBurden"],
    "Selector.GrpCore1.varCore1Fs": ["CoreSecurityFactor"],
    "Selector.GrpCore1.varCore1Extension": ["CoreExtension"],
    "Selector.GrpCore2.varCore2Accuracyclass": ["CorePrecisionClass_1"],
    "Selector.GrpCore2.varCore2BurdenVA": ["CoreBurden_1"],
    "Selector.GrpCore2.varCore2Fs": ["CoreSecurityFactor_1"],
    "Selector.GrpCore2.varCore2Extension": ["CoreExtension_1"],
    "Selector.GrpCore3.varCore3Accuracyclass": ["CorePrecisionClass_2"],
    "Selector.GrpCore3.varCore3BurdenVA": ["CoreBurden_2"],
    "Selector.GrpCore3.varCore3Fs": ["CoreSecurityFactor_2"],
    "Selector.GrpCore3.varCore3Extension": ["CoreExtension_2"],
    "Selector.GrpCore4.varCore4Accuracyclass": ["CorePrecisionClass_3"],
    "Selector.GrpCore4.varCore4BurdenVA": ["CoreBurden_3"],
    "Selector.GrpCore4.varCore4Fs": ["CoreSecurityFactor_3"],
    "Selector.GrpCore4.varCore4Extension": ["CoreExtension_3"],
    "Selector.GrpCore5.varCore5Accuracyclass": ["CorePrecisionClass_4"],
    "Selector.GrpCore5.varCore5BurdenVA": ["CoreBurden_4"],
    "Selector.GrpCore5.varCore5Fs": ["CoreSecurityFactor_4"],
    "Selector.GrpCore5.varCore5Extension": ["CoreExtension_4"],
    "Selector.GrpCore6.varCore6Accuracyclass": ["CorePrecisionClass_5"],
    "Selector.GrpCore6.varCore6BurdenVA": ["CoreBurden_5"],
    "Selector.GrpCore6.varCore6Fs": ["CoreSecurityFactor_5"],
    "Selector.GrpCore6.varCore6Extension": ["CoreExtension_5"],

    "APICalls": {
        "Selector.varType": ["Type", "VoltageLevel", "Current", "Dimension"],
        "Selector.varCompleteratioA": ["Core"],
        "Selector.varStandard": ["Standard"],
        "Selector.varIthtimeIdynkA": ["ThermalCurrent", "DynamicCurrent"],
        "Selector.GrpCore1.varCore1Accuracyclass": ["CorePrecisionClass"],
        "Selector.GrpCore2.varCore2Accuracyclass": ["CorePrecisionClass"],
        "Selector.GrpCore3.varCore3Accuracyclass": ["CorePrecisionClass"],
        "Selector.GrpCore4.varCore4Accuracyclass": ["CorePrecisionClass"],
        "Selector.GrpCore5.varCore5Accuracyclass": ["CorePrecisionClass"],
        "Selector.GrpCore6.varCore6Accuracyclass": ["CorePrecisionClass"],
        "Selector.GrpCore1.varCore1BurdenVA": ["CoreBurden","System"],
        "Selector.GrpCore2.varCore2BurdenVA": ["CoreBurden","System"],
        "Selector.GrpCore3.varCore3BurdenVA": ["CoreBurden","System"],
        "Selector.GrpCore4.varCore4BurdenVA": ["CoreBurden","System"],
        "Selector.GrpCore5.varCore5BurdenVA": ["CoreBurden","System"],
        "Selector.GrpCore6.varCore6BurdenVA": ["CoreBurden","System"],
        "Selector.GrpCore1.varCore1Fs": ["System"],
        "Selector.GrpCore2.varCore2Fs": ["System"],
        "Selector.GrpCore3.varCore3Fs": ["System"],
        "Selector.GrpCore4.varCore4Fs": ["System"],
        "Selector.GrpCore5.varCore5Fs": ["System"],
        "Selector.GrpCore6.varCore6Fs": ["System"]
    }
};